import { getMobileAndDesktopFirstImage } from 'components/PageSections/utils';

import { JustunoLoaderProps } from './JustunoLoader';

export function parserJustunoLoader(
  section: Queries.ContentfulSection001,
): JustunoLoaderProps {
  const { images, metadata } = section || {};
  const sectionImages = getMobileAndDesktopFirstImage(images);
  const { theme } = metadata || {};

  return {
    mobileBackgroundImage: sectionImages.mobileImage,
    desktopBackgroundImage: sectionImages.desktopImage,
    backgroundColor: theme?.backgroundColor,
  };
}
